<template>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { CommonServices } from '@/services/CommonServices';

@Options({})
export default class SideMenu extends Vue {


}
</script>

<style scoped>
</style>
